<template>
  <div :class="$style.ctn">
    <FallbackMedia
      is="video"
      controls
      :class="$style.video"
      :source="video"
      preload="none"
      loading="lazy"
    />
    <Ancor name="Screenshots" />
    <ScreenshotsSwiper :class="$style.screenshots" :values="screenshots" />
    <TipMessage :class="$style.tipMessage" :full-report-link-at-end="true">
      All screenshots are available in the
    </TipMessage>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import Ancor from './Ancor.vue';
import FallbackMedia from './FallbackMedia.vue';
import ScreenshotsSwiper from './ScreenshotsSwiper.vue';
import TipMessage from './TipMessage.vue';

export default defineComponent({
  components: { ScreenshotsSwiper, TipMessage, Ancor, FallbackMedia },
  inject: ['root'],
  computed: {
    video() {
      return this.root.videoAndScreenshots.video;
    },
    screenshots() {
      return this.root.videoAndScreenshots.screenshots;
    },
  },
});
</script>

<style lang="scss" module>
.ctn {
  padding-top: 20px;
}
.video {
  width: 100%;
  height: auto;
  background: #c4c4c4;

  display: block;
  margin-bottom: 15px;
  @media print {
    display: none;
  }
  // aspect-ratio: 16 / 9;
  &:before {
    float: left;
    padding-top: 56.25%;
    content: '';
  }
  &::after {
    display: block;
    content: '';
    clear: both;
  }
}
.screenshots {
  & + .tipMessage {
    margin-top: 20px;
  }
}
</style>
